/**
 * A module of methods that you want to include in all stores.
 * This module is consumed by `createStore`.
 */
"use strict";

module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/reflux-core/lib/StoreMethods.js
 ** module id = 414
 ** module chunks = 0
 **/